const APP_LOGO_URL = "https://assets.polymet.ai/educational-beige-754806";

interface AppScreenLoaderProps {
  fullScreen?: boolean;
}

export default function AppScreenLoader({
  fullScreen = false,
}: AppScreenLoaderProps) {
  return (
    <div
      className={[
        "grid w-full place-items-center px-6 text-center",
        fullScreen
          ? "min-h-screen"
          : "min-h-[calc(100vh-4rem)] lg:min-h-[calc(100vh-5rem)]",
      ].join(" ")}
    >
      <div className="mx-auto flex max-w-max flex-col items-center justify-center">
        <img
          src={APP_LOGO_URL}
          alt="ARK Arrival"
          className="mx-auto mb-6 w-44 drop-shadow-2xl sm:w-56"
        />

        <div className="flex items-center justify-center gap-3">
          <span className="h-3 w-3 rounded-full bg-[#C59A4A] animate-pulse" />
          <span className="h-3 w-3 rounded-full bg-[#C59A4A]/80 animate-pulse [animation-delay:120ms]" />
          <span className="h-3 w-3 rounded-full bg-[#C59A4A]/60 animate-pulse [animation-delay:240ms]" />
        </div>

      </div>
    </div>
  );
}
